/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {

    export class MeevoCountryField implements angular.IDirective {
        restrict = "E";
        require = "ngModel";
        scope = {
            ngModel: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            tabIndex: "=?",
            change: "&ngChange"
        };

        templateUrl = "app/components/controls/countryTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {

            scope.countries = [];
            for (var countryEnum in Meevo.Model.CountryIdEnum) {
                if (!Number(countryEnum)) {
                    let id = countryEnum.substr(3).toUpperCase();
                    let countryId = Meevo.Model.CountryIdEnum[countryEnum];
                    let name = Meevo.Model.CountryEnum[countryId].replace(/([A-Z])/g, ' $1').trim();
                    let country = { id: id, name: name }
                    scope.countries.push(country);
                }
            }

            scope.countries.push({ id: "OTHER", name: "Other" });

        }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new MeevoCountryField();
            };

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoCountryField", MeevoCountryField.factory());
}